import { MobileVariant } from "../../../../types";
import { HorizontalLine, LineWrapper, SubTitle, Title, Wrapper, } from "./styled";
import React from "react";
export const LinkContent = ({ active, subTitle, title, mobileVariant, isMobileLayout, branding, }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(Wrapper, { "$hasSubTitle": !!subTitle },
            React.createElement(Title, { "$isMobileLayout": isMobileLayout, branding: branding }, title),
            isMobileLayout && mobileVariant === MobileVariant.HORIZONTAL_LINE && (React.createElement(LineWrapper, null,
                React.createElement(HorizontalLine, { "$active": active, branding: branding })))),
        subTitle && (React.createElement(SubTitle, { "$isMobileLayout": isMobileLayout, branding: branding }, subTitle))));
};
//# sourceMappingURL=index.js.map